import React from 'react';
import Popover from 'react-popover';
import ReactTimeout from 'react-timeout';

// TODO refactor this component

class Dropdown extends React.Component {
  state = {
    open: false,
  };

  setOpen = (open, f) => {
    if (open && !this.state.open) {
      if (this.props.contentComponent) {
        this.content = this.props.contentComponent;
        this.contentProps = { close: f => this.setOpen(false, f) };
      } else {
        this.content = this.props.content({
          close: f => this.setOpen(false, f),
        });
        this.contentProps = {};
      }
    }

    this.setState(
      {
        open,
      },
      () => {
        if (!this.state.open) {
          this.content = null;
        }
        if (f) {
          f();
        }
      }
    );
  };

  render() {
    const {
      children,
      content,
      contentComponent,
      hover,
      position,
      duration,
      showTip = true,
      contentProps = {},
      disabled,
      // Filter out react-timeout HOC props to prevent them from being passed to DOM
      setTimeout,
      clearTimeout,
      setInterval,
      clearInterval,
      setImmediate,
      clearImmediate,
      requestAnimationFrame,
      cancelAnimationFrame,
      // Filter out custom props that shouldn't be passed to DOM
      customPicker,
      ...props
    } = this.props;
    const { open } = this.state;
    const PassedContent = this.content;
    return (
      <Popover
        style={{ zIndex: 5000 }}
        isOpen={open}
        body={open ? <PassedContent {...{ ...this.contentProps, ...contentProps }} /> : <span />}
        preferPlace={position || 'below'}
        enterExitTransitionDurationMs={duration || 500}
        onOuterAction={() => this.setOpen(false)}
        tipSize={showTip ? 7 : 0.01}
      >
        <div
          {...props}
          onClick={() => (!disabled ? this.setOpen(!open) : undefined)}
          onMouseEnter={() => hover && this.setOpen(true)}
          onMouseLeave={() => hover && this.setOpen(false)}
        >
          {children}
        </div>
      </Popover>
    );
  }
}

export default ReactTimeout(Dropdown);
